import { FC } from 'react'
import { InputContainerButton } from './common'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const TuneButton: FC<Props> = ({ onClick, disabled }) => {
  return (
    <InputContainerButton onClick={() => onClick()} tooltipText="Tune to Song" disabled={disabled}>
      Tune
    </InputContainerButton>
  )
}

export default TuneButton
